<script setup>
import {computed, onMounted} from 'vue'
import {useFormsStore} from '@/stores/forms'
import {useFormStore} from '@/stores/form'
import {useNavigationStore} from '@/stores/navigation'
import {useAppStore} from '@/stores/appStore'
import FormNavAndForm from '@/common/form/FormNavAndForm'
import FormHeader from '@/common/form/FormHeader'

const props = defineProps({
    // Add props here if they are passed from the router/parent
})

const appStore = useAppStore()
const formsStore = useFormsStore()
const navigationStore = useNavigationStore()

const id = 1
const tableName = 'account_settings'
const formId = `form:${tableName}:${id}`
const formStore = useFormStore(formId)

const formExists = computed(() => !!formStore.fields && formStore.fields.length > 0)

onMounted(() => {
    appStore.navigationComponent = 'account_settings'

    formsStore.createForm({
        tableName: tableName,
        id: id
    })
})
</script>

<template>
    <div class="d-flex h-100 overflow-auto flex-column">
        <template v-if="formExists">
            <FormHeader :form-id="formId" :show-save-btn="true"/>

            <FormNavAndForm :form-id="formId" class="flex-grow-1"/>
        </template>

        <div v-else class="flex-grow-1 d-flex align-items-center justify-content-center">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>
    </div>
</template>